import gigya from './rbata.gigya';
import urlService from '../services/rbata.urlService';
import logger from "../utils/rbata.logger";

const gigyaProfileUpdate = {

    // screen ids
    CDC_CHANGE_PASSWORD_SCREEN: 'gigya-change-password-screen',
    CDC_MANAGE_SUBSCRIPTIONS_SCREEN: 'gigya-manage-subscriptions-screen',
    CDC_UPDATE_PROFILE_SCREEN: 'gigya-update-profile-screen',

    //variables
    $newsletterCheckbox: undefined,
    $newsletterWrapper: undefined,
    isSubscribed: false,
    $targetValidationContainer: null,
    $targetValidationSubmit: null,
    $body: undefined,
    $2stepUnsubscribeBtn: undefined,
    $2stepUnsubscribeSuccess: undefined,
    $2stepUnsubscribeNoSubscription: undefined,
    $2stepUnsubscribeFailed: undefined,


    // At the moment the state of the subscriptions is derived from the state of the checkbox (slider).
    // I think that could lead to many inconsistencies
    // Better approach would be to ask CDC again, for example
    // doc: https://developers.gigya.com/display/GD/accounts.getAccountInfo+JS
    /*
        function foobar() {
            gigya.accounts.getAccountInfo({
                include:  'subscriptions',
                callback: function (response) {
                    if (response.errorCode == 0) {
                        console.log(response.subscriptions)
                    } else {
                        console.error('Error :' + response.errorMessage);
                    }
                }
            });
        }
    */

    cacheSelectors() {
        this.$body = $('body');
        this.$2stepUnsubscribeBtn = this.$body.find('#js-2-step-unsubscribe');
        this.$2stepUnsubscribeSuccess = this.$body.find('.newsletter__unsubscribe-message--success');
        this.$2stepUnsubscribeNoSubscription = this.$body.find('.newsletter__unsubscribe-message--no-sub');
        this.$2stepUnsubscribeFailed = this.$body.find('.newsletter__unsubscribe-message--failed');
    },

    bindEvents() {
        this.$2stepUnsubscribeBtn.on('click', gigyaProfileUpdate.twoStepNewsletterUnsubscribe);
    },

    onScreenLoaded: (evt) => {
        var data = evt.detail;

        gigya.showPasswordCheckbox();
        // NEWSLETTER SUBSCRIPTION SCREEN LOADED
        if (data.currentScreen === gigyaProfileUpdate.CDC_MANAGE_SUBSCRIPTIONS_SCREEN) {
            gigyaProfileUpdate.$newsletterWrapper = $('#cdc-gigya-manage-subscriptions-container');
            gigyaProfileUpdate.$newsletterCheckbox = $('.gigya-screen-content .gigya-newsletter-subscribe--main input');
            const elementMarker = $('.gigya-element-marker');
            //add specific class to parent row to manage visibility later
            elementMarker.closest('.gigya-layout-row').addClass('checkbox-row');
            $('.gigya-newsletter-language').closest('.gigya-layout-row').addClass('checkbox-row');
            //the button wrapper's css class is misplaced, so we need this as well
            elementMarker.closest('.gigya-layout-ro').addClass('checkbox-row');
            $('.gigya-input-submit').prop('disabled', true);
            gigyaProfileUpdate.subscriptionInitialMessages();
            gigyaProfileUpdate.isSubscribed = gigyaProfileUpdate.$newsletterCheckbox.prop('checked');
            gigyaProfileUpdate.$newsletterCheckbox.addClass('checkbox-switch')
                .on('change', gigyaProfileUpdate.updateNewsletterSettings)
                .prop('checked') ? gigyaProfileUpdate.subscriptionInterestsShow() : gigyaProfileUpdate.subscriptionInterestsShow(false);

            gigyaProfileUpdate.$newsletterCheckbox.after('<div id="js-checkbox-switch-button" class="checkbox-switch-button"></div>');

            const $body = $('body');
            //bind tooltip buttons
            $body.on('click', '#unsubscribe-tooltip-no', gigyaProfileUpdate.tooltipCancel);
            $body.on('click', '#unsubscribe-tooltip-yes', gigyaProfileUpdate.tooltipConfirm);

            gigyaProfileUpdate.changedInterests();
        }

        if (data.currentScreen === gigyaProfileUpdate.CDC_UPDATE_PROFILE_SCREEN || data.sourceContainerID === gigyaProfileUpdate.CDC_CHANGE_PASSWORD_SCREEN) {
            gigyaProfileUpdate.$targetValidationContainer = $('#' + data.sourceContainerID);
            gigyaProfileUpdate.$targetValidationSubmit = gigyaProfileUpdate.$targetValidationContainer.find('.gigya-input-submit');
            $('#' + data.sourceContainerID + ' .gigya-input-submit').prop('disabled', true);
        }
    },

    onError: (evt) => {
        var data = evt.detail;
    },

    onBeforeSubmit: (evt) => {
        var data = evt.detail;

        if (data.sourceContainerID === gigyaProfileUpdate.CDC_CHANGE_PASSWORD_SCREEN) {
            document.querySelector('#accountChangePasswordStatus').setAttribute('hidden', true);
        }
    },

    onSubmit: (evt) => {
        if ('detail' in evt) {
            var data = evt.detail;

            if (data.screen === gigyaProfileUpdate.CDC_MANAGE_SUBSCRIPTIONS_SCREEN) {
                // TODO: maybe some fixes needed
                gigyaProfileUpdate.isSubscribed = gigyaProfileUpdate.$newsletterCheckbox.prop('checked');
                $('.gigya-input-submit').prop('disabled', true);
            }

            if (data.screen === gigyaProfileUpdate.CDC_UPDATE_PROFILE_SCREEN) {
                gigya.clearEmailForLoggedIn(evt);
            }
        }
    },

    onFieldChange: (evt) => {
        var data = evt.detail;

        if (!gigyaProfileUpdate.$targetValidationContainer || !gigyaProfileUpdate.$targetValidationContainer.length) {
            return;
        }

        // in a world without CDC this code will be better
        setTimeout(function () {
            var $targetValidFields = gigyaProfileUpdate.$targetValidationContainer.find('.gigya-valid');
            var $targetErrorFields = gigyaProfileUpdate.$targetValidationContainer.find('.gigya-error');
            if (data.screen === gigyaProfileUpdate.CDC_UPDATE_PROFILE_SCREEN) {
                if ($targetValidFields.length && !$targetErrorFields.length) {
                    gigyaProfileUpdate.$targetValidationSubmit.prop('disabled', false)
                } else {
                    gigyaProfileUpdate.$targetValidationSubmit.prop('disabled', true)
                }
            }
            if (data.sourceContainerID === gigyaProfileUpdate.CDC_CHANGE_PASSWORD_SCREEN) {
                if ($targetValidFields.length >= 2 && !$targetErrorFields.length) {
                    gigyaProfileUpdate.$targetValidationSubmit.prop('disabled', false)
                } else {
                    gigyaProfileUpdate.$targetValidationSubmit.prop('disabled', true)
                }
            }
        }, 1);

    },

    updateNewsletterSettings: (evt) => {

        var checkboxValue = $(evt.currentTarget),
            $newsletterSwitchTooltip = $('.checkbox-switch-button');
        // current status of checkbox switch
        if (checkboxValue.prop('checked') === false) {
            if (gigyaProfileUpdate.isSubscribed) {
                // $('.tooltip-unsubscribe').removeClass('hide');
                $('#manage-subscription__reveal').foundation('open');
                $('.checkbox-switch ').prop('checked', true);
            } else {
                gigyaProfileUpdate.subscriptionInterestsShow(false);
                $('.gigya-input-submit').prop('disabled', true);
            }
        } else {

            // reset "Save all changes" message
            $('#subsSaveChangeMsg').show();

            gigyaProfileUpdate.subscriptionInterestsShow();
            $('.gigya-input-submit').prop('disabled', false);
            gigyaProfileUpdate.updateNsStatusMsg(document.getElementById('saveChangeMsgsaveChangeMsg').innerText);
        }
    },

    updateNsStatusMsg: (text) => {

        if (typeof text != 'string') {
            console.error('Trying to update ns status with something else than String');
            return;
        }

        var nsSubscriptionStatus = document.querySelector('main .gigya-newsletter-subcribe-status');
        nsSubscriptionStatus.innerText = text;
    },

    subscriptionInitialMessages: () => {

        // fetch current state from CDC

        function updateSubscriptionMessage(response) {

            var nsSubscriptionStatus = document.querySelector('main .gigya-newsletter-subcribe-status');

            if (response.errorCode != 0) {
                console.error('Cannot obtain ns subscription status');
                nsSubscriptionStatus.innerText = typeof response.errorMessage === 'string' ? response.errorMessage : 'Error';
                return;
            }

            var isSubscribed = response.subscriptions.newsletter.email.isSubscribed;
            var isPending = response.subscriptions.newsletter.email.doubleOptIn.status === 'Pending';

            if (typeof isSubscribed != 'boolean') {
                // response does not contain expected field!
                console.error('CDC response does not contain expected field!');
                return;
            }

            if (!isSubscribed) {
                nsSubscriptionStatus.innerText = document.getElementById('notSubscribedInfoMsg').innerText;
            } else if (isPending) {
                nsSubscriptionStatus.innerText = document.getElementById('pendingInfoMsg').innerText;
            } else {
                nsSubscriptionStatus.innerText = document.getElementById('subscribedInfoMsg').innerText;
            }
        }

        gigya.accounts.getAccountInfo({include: 'subscriptions', callback: updateSubscriptionMessage});
    },

    subscriptionInterestsShow: (boolean) => {
        var checkboxRow = $('.checkbox-row');
        if (boolean === undefined || boolean === null) {
            boolean = true;
        }
        boolean ? checkboxRow.show() : checkboxRow.hide()
    },

    changedInterests: () => {
        gigyaProfileUpdate.$newsletterWrapper.on('change', '.checkbox-row input, .checkbox-row select', function () {
            $('.gigya-input-submit').prop('disabled', false);
        });
    },

    tooltipCancel: () => {
        // $('.tooltip-unsubscribe').addClass('hide');
        $('#manage-subscription__reveal').foundation('close');
    },

    tooltipConfirm: () => {
        gigyaProfileUpdate.subscriptionInterestsShow(false);
        gigyaProfileUpdate.$newsletterWrapper.find('.checkbox-row input').prop('checked', false);
        $('.checkbox-switch ').prop('checked', false);
        $('.gigya-input-submit').prop('disabled', false).click();
        // $('.tooltip-unsubscribe').addClass('hide');
        $('#manage-subscription__reveal').foundation('close');
    },

    twoStepNewsletterUnsubscribe() {
        const queryString = window.location.search;
        const token = new URLSearchParams(queryString).get('channelToken');
        gigyaProfileUpdate.$2stepUnsubscribeBtn.prop('disabled', true);
        $.ajax({
            url: `${urlService.getBaseUrl()}/newsletter/unsubscribe-two-step/`,
            method: 'POST',
            cache: false,
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({channelToken: token})
        }).done((data) => {
            gigyaProfileUpdate.twoStepMessageControl(data);
        }).fail((data) => {
            logger.log('Something went wrong with unsubscribe request');
            logger.log(data);
        }).always(() => {
            gigyaProfileUpdate.$2stepUnsubscribeBtn.removeAttr('disabled');
        });
    },

    twoStepMessageControl(data) {
        const {errors, noSubscription, success} = data;
        const hideClass = 'd-none';

        gigyaProfileUpdate.$2stepUnsubscribeBtn.addClass(hideClass);

        if (noSubscription) {
            this.$2stepUnsubscribeNoSubscription.removeClass(hideClass);
        }

        if (success) {
            this.$2stepUnsubscribeSuccess.removeClass(hideClass);
        }

        if (errors.length > 0) {
            this.$2stepUnsubscribeFailed.removeClass(hideClass);
        }
    },

    bindHandler: () => {
        // Called after a new screen is rendered.
        document.addEventListener('gigya-profile-update-after-screenload', gigyaProfileUpdate.onScreenLoaded);
        // Called when an error occurs.
        document.addEventListener('gigya-profile-update-error', gigyaProfileUpdate.onError);
        // Called before a form will be submitted
        document.addEventListener('gigya-profile-update-before-submit', gigyaProfileUpdate.onBeforeSubmit);
        // Called when a form is submitted
        document.addEventListener('gigya-profile-update-submit', gigyaProfileUpdate.onSubmit);
        // Called after a form is submitted
        // NOTE: onAfterSubmit event is overridden in gigyaloginaddon.js line 135
        // Called when a field is changed in a managed form.
        document.addEventListener('gigya-profile-update-field-change', gigyaProfileUpdate.onFieldChange);
    }
};

$(() => {
    gigyaProfileUpdate.cacheSelectors();
    gigyaProfileUpdate.bindEvents();
});

export default gigyaProfileUpdate;
